export default "__VITE_ASSET__DfkHP9Zt__"